// extracted by mini-css-extract-plugin
export default {"userOptin":"KHs-aHBUxMJrxeakAbotdIpXu3p8NuTt5EZph+AFyWA="};